<template>
  <div id="mainFrame">
    <div id="WarningPopupNewQuiz" class="popupCard">
      <div class="card">
        <h1>Vous n'avez pas terminé un quiz</h1>
        <p>Vous avez laissé un quiz sans l'avoir terminé. Voulez-vous reprendre ce quiz là où vous vous êtiez arrété la dernière fois, ou souhaitez-vous en recommencer un nouveau ?</p>
        <div class="button_container">
          <div class="button" @click="closePopup">Continuer</div>
          <div class="button" @click="loadQuiz">Recommencer</div>
        </div>
      </div>
      <div class="popupCard_background"></div>
    </div>
    <div id="WarningPopupHowManyQuiz" style="display: none" class="popupCard">
      <div class="card">
        <h1>Entrainement à l'examen</h1>
        <p>Vous vous apprêtez à lancer un test sur tous les sujets d'une UE. Vous pouvez choisir le nombre de QCM qui composeront cet entrainement :</p>
        <div id="slide-container">
          <input v-model="nbQRequested" type="range" min="1" :max="nbQ" id="slider-nbQ"/>
        </div>
        <p>Votre test sera composé de {{ nbQRequested }} QCM.</p>
        <div class="button_container">
          <div class="button" @click="loadExam">C'est partit !</div>
        </div>
      </div>
      <div class="popupCard_background"></div>
    </div>
    <div v-if="ended">
      <div class="card card_end">
        <h3>Test terminé, votre score est de :</h3>
        <h1>{{ score }} / {{ nbQ }}</h1>
        <div v-if="score/nbQ<0.5">Encore un petit effort ! Le score n'est pas parfait, tu peux t'améliorer : relis bien les réponses aux questions pour comprendre où tu t'es trompé.</div>
        <div v-else-if="score/nbQ<0.7">Bien joué, n'hésite pas à relire les réponses aux questions pour comprendre où tu t'es trompé et faire encore mieux la prochaine fois.</div>
        <div v-else>Joli score, bravo ! Il semblerait que tu maîtrise ce sujet, beau travail !</div>
      </div>
      <div class="end_button_container">
        <router-link class="button end_button" to="/">
          <div>Retour à l'accueil</div>
        </router-link>
        <router-link class="button end_button" :to="'/' + ue.link">
          <div>{{ ue.name }}</div>
        </router-link>
      </div>
      <div
          v-for="(question, q_index) in attempts"
          :key="q_index"
          class="card"
        >
        <h3 :class="{questionTitleBad: !question.success}">{{ quiz[q_index].question }}</h3>
        <span>{{ question.comment }}</span>

        <div id="question_response_div">
          <div v-if="quiz[q_index].type === 'QCM'">
            <div v-for="(p, index) in quiz[q_index].choices" :key="index">
              <div
                  class="button QCMButton QCMButtonNoSelect"
                  :class="{
                    QCMButtonSelected: question.response.includes(index)
                    }">
                <div class="ResponseLetter">{{ alphabet[index] }}</div>
                <p>{{ p }}</p>
              </div>
            </div>
            <div
                v-if="quiz[q_index].response.length === 0"
                class="button QCMButton"
                :class="{
                  QCMButtonSelected: question.response.includes(quiz[q_index].choices.length)
                }">
              <div class="ResponseLetter">{{ alphabet[quiz[q_index].choices.length] }}</div>
              <p>Aucune des propositions précédentes n'est vraie</p>
            </div>
          </div>


          <div v-else-if="quiz[q_index].type === 'TF'">
            <div
                class="button QCMButton QCMButtonNoSelect"
                :class="{QCMButtonSelected: question.response === true}">
              <div class="ResponseLetter">V</div>
              <p>Vrai</p>
            </div>
            <div
                class="button QCMButton QCMButtonNoSelect"
                :class="{QCMButtonSelected: question.response === false}">
              <div class="ResponseLetter">F</div>
              <p>Faux</p>
            </div>
          </div>


          <div v-else-if="quiz[q_index].type === 'Number' || quiz[q_index].type === 'Range'" class="InputDiv">
            <input
                class="quiz_input"
                readonly="readonly"
                :placeholder="question.response"
            >
            <div class="check_is_ok"><div :class="question.success?'check_is_true':'check_is_false'"></div></div>
          </div>


          <div v-else-if="quiz[q_index].type === 'Text'" class="InputDiv">
            <input
                class="quiz_input"
                type="text"
                readonly="readonly"
                :placeholder="question.response"
            >
            <div class="check_is_ok"><div :class="question.success?'check_is_true':'check_is_false'"></div></div>
          </div>
        </div>

        <p v-for="(text, t_index) in quiz[q_index].tips" :key="t_index">{{ text }}</p>
      </div>
      <div class="end_button_container">
        <router-link class="button end_button" to="/">
          <div>Retour à l'accueil</div>
        </router-link>
        <router-link class="button end_button" :to="'/' + ue.link">
          <div>{{ ue.name }}</div>
        </router-link>
      </div>
    </div>
    <div v-else>
      <div id="scores" v-if="!ended" class="card"><h1>{{ score }}/{{ lastQ }}</h1></div>
      <div id="questionHalf">
        <div>
          <span>Question {{ qNb }} sur {{ nbQ }}</span>
          <h2 v-if="quiz[0]">{{ currentQuiz.question }}</h2>
        </div>
        <div id="responseCorner" v-if="attempts[qNb-1]">
            <h3>{{ attempts[qNb-1].message }}</h3>
            <div class="textComment responseComment">{{ attempts[qNb-1].comment }}</div>
            <div class="responseTips" v-for="(text, index) in attempts[qNb-1].text" :key="index">{{ text }}</div>
          </div>
      </div>
      <div id="responseHalf" v-if="quiz[0]">
        <div>

          <div v-if="currentQuiz.type === 'QCM'">
            <div v-for="(p, index) in currentQuiz.choices" :key="index">
              <div
                  class="button QCMButton"
                  v-bind:class="{
                    QCMButtonSelected: (!attempts[qNb-1] && selectedQCMOption.includes(index)) || (attempts[qNb-1] && attempts[qNb-1].response.includes(index)),
                    QCMButtonHover: !attempts[qNb-1],
                    QCMButtonSelectedHover: selectedQCMOption.includes(index) && !attempts[qNb-1]}"
                  @click="selectQCMOption(index)">
                <div class="ResponseLetter">{{ alphabet[index] }}</div>
                <p>{{ p }}</p>
              </div>
            </div>
            <div
                v-if="currentQuiz.response.length === 0"
                class="button QCMButton"
                v-bind:class="{
                  QCMButtonSelected: (!attempts[qNb-1] && selectedQCMOption.includes(currentQuiz.choices.length)) || (attempts[qNb-1] && attempts[qNb-1].response.includes(currentQuiz.choices.length)),
                  QCMButtonHover: !attempts[qNb-1],
                  QCMButtonSelectedHover: selectedQCMOption.includes(currentQuiz.choices.length) && !attempts[qNb-1]
                }"
                @click="selectQCMOption(currentQuiz.choices.length)">
              <div class="ResponseLetter">{{ alphabet[currentQuiz.choices.length] }}</div>
              <p>Aucune des propositions précédentes n'est vraie</p>
            </div>
          </div>


          <div v-else-if="currentQuiz.type === 'TF'">
            <div
                class="button QCMButton"
                v-bind:class="{
                  QCMButtonSelected: (!attempts[qNb-1] && current_attempt === true) || (attempts[qNb-1] && attempts[qNb-1].response === true),
                  QCMButtonHover: !attempts[qNb-1],
                  QCMButtonSelectedHover: current_attempt === true && !attempts[qNb-1]
                }"
                @click="true_false(true)">
              <div class="ResponseLetter">V</div>
              <p>Vrai</p>
            </div>
            <div
                class="button QCMButton"
                v-bind:class="{ QCMButtonSelected: current_attempt === false}"
                @click="true_false(false)">
              <div class="ResponseLetter">F</div>
              <p>Faux</p>
            </div>
          </div>


          <div v-else-if="currentQuiz.type === 'Number' || currentQuiz.type === 'Range'" class="InputDiv">
            <input
                v-model="current_attempt"
                class="quiz_input"
                :type="!attempts[qNb-1]?'number':''"
                @keypress="isNumber($event)"
                :readonly="!!attempts[qNb-1]"
                :placeholder="attempts[qNb-1] ? attempts[qNb-1].response : ''"
            >
            <div v-if="!!attempts[qNb-1]" class="check_is_ok">
              <div :class="attempts[qNb-1].success?'check_is_true':'check_is_false'"></div>
            </div>
          </div>


          <div v-else-if="currentQuiz.type === 'Text'" class="InputDiv">
            <input
                v-model="current_attempt"
                class="quiz_input"
                type="text"
                :readonly="!!attempts[qNb-1]"
                :placeholder="attempts[qNb-1] ? attempts[qNb-1].response : ''"
            >
            <div v-if="!!attempts[qNb-1]" class="check_is_ok">
              <div :class="attempts[qNb-1].success?'check_is_true':'check_is_false'"></div>
            </div>
          </div>


          <div id="buttonContainer">
            <div @click="b_previous" class="button" v-bind:class="{ b_gray: qNb === 1}">
              Précédent
              <span class="helpSign">🠔 Retour arrière</span>
            </div>

            <div
                @click="b_next_or_validate"
                class="button"
                v-bind:class="{ b_gray: validateOrWhat === 1, b_validate: validateOrWhat >= 2 }"
            >
              {{ ['Suivant', 'Valider', 'Valider', 'Terminer le quiz'][validateOrWhat]}}
              <span class="helpSign">⤷ Entrée</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-link to="/bug" id="report-flag_a">
      <img src="../assets/flag.png" alt="report flag" id="report-flag">
    </router-link>
  </div>
</template>

<style scoped>
  #mainFrame {
    margin-bottom: 40px;
  }
  #slide-container {
    margin: 7px 0;
  }
  #slider-nbQ {
    -webkit-appearance: none;
    width: 100%;
    height: 17px;
    border-radius: 9px;
    background: var(--color-text-5);
    outline: none;
    opacity: 1;
    -webkit-transition: opacity .15s ease-in-out;
    transition: opacity .15s ease-in-out;
  }
  /* The slider handle*/
  #slider-nbQ::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    border: none;
    appearance: none;
    width: 34px;
    height: 17px;
    background: var(--color-main);
    cursor: pointer;
  }
  #slider-nbQ::-moz-range-thumb {
    border: none;
    width: 34px;
    height: 17px;
    background: var(--color-main);
    cursor: pointer;
  }
  .QCMButton {
    box-sizing: border-box;
    width: 100%;
    text-align: left;
    margin: 7px 0;
    padding: 16px 0;
    transition: background-color .3s;
    position: relative;
  }
  .QCMButtonNoSelect {
    cursor: default;
  }
  .QCMButton > p {
    padding-right: 24px;
    padding-left: 53px;
  }
  .QCMButtonSelected {
    background-color: var(--color-selected);
  }
  .QCMButtonSelected > .ResponseLetter {
    border-color: var(--color-light);
    color: var(--color-light);
  }
  .ResponseLetter {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translate(0, -50%);
    font-weight: 700;
    border: solid 1px var(--color-text-4);
    color: var(--color-text-4);
    padding: 3px 0;
    text-align: center;
    width: 25px;
    border-radius: 6px;
  }
  .textComment {
    word-break: break-word;
  }
  .card_end {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .end_button_container {
    display: flex;
    justify-content: space-between;
    gap: 2%;
    margin: 0 50px;
  }
  .end_button {
    width: 48%;
    background-color: var(--color-cards);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .end_button:hover {
    background-color: var(--color-selected-hover);
  }

  #report-flag_a {
    position: absolute;
    right: 20px;
    bottom: 10px;
  }
  #report-flag {
    height: 30px;
    opacity: .15;
  }

  @media screen and (min-width: 1200px) {
    #scores {
      position: absolute;
      left: 40%;
      z-index: 2;
      transform: translate(-50%, 0);
      padding: 18px 18px 10px;
      margin: unset;
      border-radius: 0 0 16px 16px;
    }
    #scores > h1 {
      margin: unset;
    }


    #questionHalf, #responseHalf {
      position: absolute;
      top: 75px;
      bottom: 0;
    }
    #questionHalf {
      left: 0;
      right: 60%;
      padding: 80px 50px;
      box-shadow: 15px 0 15px -20px var(--color-text-4);
      background: linear-gradient(var(--color-cards) -20%, var(--color-footer-1) 300%);
    }
    #responseHalf {
      left: 40%;
      right: 0;
      padding: 90px 70px;
    }

    #responseCorner {
      margin-top: 40px;
    }

    #buttonContainer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    #buttonContainer > div {
      margin-right: 20px;
      position: relative;
    }
    .b_validate {
      background-color: var(--color-good);
      color: var(--color-light);
      font-weight: 500;
    }
    .b_gray {
      background-color: var(--color-cards);
      color: var(--color-text-4);
      cursor: unset;
    }
    .helpSign {
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translate(-50%, 100%);
      font-size: 12px;
      white-space: nowrap;
    }

    .quiz_input {
      all: unset;
      box-sizing: border-box;
      padding: 12px 24px;
      border-radius: 8px;
      background-color: var(--color-cards);
      width: 100%;
    }
    .responseComment {
      margin-top: 5px;
    }
    .responseTips {
      margin-top: 10px;
    }


    .InputDiv {
      position: relative;
    }
    .check_is_ok {
      transform: rotate(45deg);
      height: 100%;
      aspect-ratio: 1;
      transform-origin: center;
      position: absolute;
      top: 0;
      right: 12px;
    }
    .check_is_true {
      position: absolute;
      top: 0;
      left: 0;
      transform: scale(0.2);
    }
    .check_is_true:before {
      content: '';
      position: absolute;
      width:25px;
      height:85px;
      background-color: var(--color-good);
      left:110px;
      top:60px;
    }
    .check_is_true:after {
      content: '';
      position: absolute;
      width:55px;
      height:25px;
      background-color: var(--color-good);
      left:80px;
      top:120px;
    }


    .check_is_false {
      position: absolute;
      top: 16px;
      left: 16px;
      transform: scale(0.2);
    }
    .check_is_false:before {
      content: '';
      position: absolute;
      width:25px;
      height:85px;
      background-color: var(--color-bad);
      left:30px;
      top:-30px;
    }
    .check_is_false:after {
      content: '';
      position: absolute;
      width:85px;
      height:25px;
      background-color: var(--color-bad);
      left:0;
      top:0;
    }


    .questionTitleBad {
      color: var(--color-bad)
    }
    #question_response_div {
      margin: 20px 0 10px;
    }
    #question_response_div .quiz_input {
      color: var(--color-text-1)
    }
  }
  @media screen and (max-width: 1200px) {
    #scores {
      position: absolute;
      right: 0;
      padding: 14px 20px;
      margin: unset;
      background-color: unset;
      box-shadow: unset;
    }
    #scores > h1 {
      margin: unset;
      color: var(--color-text-3);
    }


    #questionHalf {
      padding: 50px 50px 40px;
    }
    #responseHalf {
      padding: 0 50px;
    }
    #responseCorner {
      margin-top: 40px;
    }




    #buttonContainer {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    #buttonContainer > div {
      margin-right: 20px;
      position: relative;
    }
    .b_validate {
      background-color: var(--color-good);
      color: var(--color-light);
      font-weight: 500;
    }
    .b_gray {
      background-color: var(--color-cards);
      color: var(--color-text-4);
      cursor: unset;
    }
    .helpSign {
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translate(-50%, 100%);
      font-size: 12px;
      white-space: nowrap;
    }

    .quiz_input {
      all: unset;
      box-sizing: border-box;
      padding: 12px 24px;
      border-radius: 8px;
      background-color: var(--color-cards);
      width: 100%;
    }
    .responseComment {
      margin-top: 5px;
    }
    .responseTips {
      margin-top: 10px;
    }


    .InputDiv {
      position: relative;
    }
    .check_is_ok {
      transform: rotate(45deg);
      height: 100%;
      aspect-ratio: 1;
      transform-origin: center;
      position: absolute;
      top: 0;
      right: 12px;
    }
    .check_is_true {
      position: absolute;
      top: 0;
      left: 0;
      transform: scale(0.2);
    }
    .check_is_true:before {
      content: '';
      position: absolute;
      width:25px;
      height:85px;
      background-color: var(--color-good);
      left:110px;
      top:60px;
    }
    .check_is_true:after {
      content: '';
      position: absolute;
      width:55px;
      height:25px;
      background-color: var(--color-good);
      left:80px;
      top:120px;
    }


    .check_is_false {
      position: absolute;
      top: 16px;
      left: 16px;
      transform: scale(0.2);
    }
    .check_is_false:before {
      content: '';
      position: absolute;
      width:25px;
      height:85px;
      background-color: var(--color-bad);
      left:30px;
      top:-30px;
    }
    .check_is_false:after {
      content: '';
      position: absolute;
      width:85px;
      height:25px;
      background-color: var(--color-bad);
      left:0;
      top:0;
    }


    .questionTitleBad {
      color: var(--color-bad)
    }
    #question_response_div {
      margin: 20px 0 10px;
    }
    #question_response_div .quiz_input {
      color: var(--color-text-1)
    }
  }
  @media screen and (max-width: 700px) {
    #scores {
      padding: 12px 16px;
    }
    #questionHalf {
      padding: 35px 25px 20px;
    }
    #responseHalf {
      padding: 0 25px;
    }
    #responseCorner {
      margin-top: 25px;
    }




    #buttonContainer {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    #buttonContainer > div {
      margin-right: 20px;
      position: relative;
    }
    .b_validate {
      background-color: var(--color-good);
      color: var(--color-light);
      font-weight: 500;
    }
    .b_gray {
      background-color: var(--color-cards);
      color: var(--color-text-4);
      cursor: unset;
    }
    .helpSign {
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translate(-50%, 100%);
      font-size: 12px;
      white-space: nowrap;
    }

    .quiz_input {
      all: unset;
      box-sizing: border-box;
      padding: 12px 24px;
      border-radius: 8px;
      background-color: var(--color-cards);
      width: 100%;
    }
    .responseComment {
      margin-top: 5px;
    }
    .responseTips {
      margin-top: 10px;
    }


    .InputDiv {
      position: relative;
    }
    .check_is_ok {
      transform: rotate(45deg);
      height: 100%;
      aspect-ratio: 1;
      transform-origin: center;
      position: absolute;
      top: 0;
      right: 12px;
    }
    .check_is_true {
      position: absolute;
      top: 0;
      left: 0;
      transform: scale(0.2);
    }
    .check_is_true:before {
      content: '';
      position: absolute;
      width:25px;
      height:85px;
      background-color: var(--color-good);
      left:110px;
      top:60px;
    }
    .check_is_true:after {
      content: '';
      position: absolute;
      width:55px;
      height:25px;
      background-color: var(--color-good);
      left:80px;
      top:120px;
    }


    .check_is_false {
      position: absolute;
      top: 16px;
      left: 16px;
      transform: scale(0.2);
    }
    .check_is_false:before {
      content: '';
      position: absolute;
      width:25px;
      height:85px;
      background-color: var(--color-bad);
      left:30px;
      top:-30px;
    }
    .check_is_false:after {
      content: '';
      position: absolute;
      width:85px;
      height:25px;
      background-color: var(--color-bad);
      left:0;
      top:0;
    }


    .questionTitleBad {
      color: var(--color-bad)
    }
    #question_response_div {
      margin: 20px 0 10px;
    }
    #question_response_div .quiz_input {
      color: var(--color-text-1)
    }
    .end_button_container {
      margin: 0 10px;
    }
  }
  @media (hover: hover) {
    .QCMButtonHover:hover {
      background-color: var(--color-hover);
    }
    .QCMButtonSelectedHover:hover {
      background-color: var(--color-selected-hover);
    }
  }
</style>


<script>
  import axios from "axios"
  const alphabet = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']

  export default {
    name: "quiz",
    data() {
      return {
        nbQ: 0,         // Number of question in the quiz
        qNb: 1,         // The number of the question we are currently reading
        score: 0,       // The total score
        lastQ: 1,       // The last accessible question
        lastQDone: 0,   // The last answered question
        quiz: [],
        selectedQCMOption: [],
        current_attempt: '',
        attempts: [],
        alphabet: alphabet,
        ended: false,
        ue: {},
        subject: {},
        nbQRequested: 10,
      }
    },
    computed: {
      currentQuiz: function () {return this.quiz[this.qNb -1] || ''},
      validateOrWhat: function () {
        // Next = 0
        // Validate & gray = 1
        // Validate & green = 2
        // Finish the test = 3

        if (this.qNb !== this.lastQ) return 0
        if (this.lastQDone === this.nbQ) return 3
        if (this.lastQ === this.lastQDone) return 0

        if (this.selectedQCMOption.length === 0 && ((!this.current_attempt && this.current_attempt !== false && this.current_attempt !== 0) || this.current_attempt === '')) return 1
        return 2
      }
    },
    mounted() {
      let quizSaved = this.backupResp()
      if (!quizSaved) this.loadQuiz()

      window.addEventListener('keydown', this.keyDownEvent)
    },
    updated() {
      this.focusIfNeeded()
    },
    methods: {
      selectQCMOption: function (index) {
        if (this.attempts[this.qNb-1]) return
        let i = this.selectedQCMOption.indexOf(index)
        if (i === -1) this.selectedQCMOption.push(index)
        else this.selectedQCMOption.splice(i, 1)
      },
      b_previous: function () {
        if (this.qNb === 1) return
        this.qNb--
      },
      b_next_or_validate: function () {
        if (this.validateOrWhat === 2) this.b_validate()
        else if (this.validateOrWhat === 0) this.b_next()
        else if (this.validateOrWhat === 3) this.theEnd()
        this.saveResp()
      },
      theEnd: function() {
        if (this.ended) return
        this.ended = true

        axios.post('/stats', {
          quiz: this.quiz,
          attempts: this.attempts
        }).then(() => {}).catch(()=>{})
        sessionStorage.setItem('ended', 'true')
      },
      b_validate: function () {
        this.check_response(this.quiz[this.qNb-1], this.quiz[this.qNb-1].type === 'QCM' ? this.selectedQCMOption : this.current_attempt)

        this.lastQDone++
        this.selectedQCMOption = []
        this.current_attempt = ''
        this.saveResp()
      },
      b_next: function () {
        if (this.qNb > this.lastQDone+1 || (this.qNb === this.lastQDone+1 && this.qNb === this.nbQ)) return
        if (this.lastQ === this.lastQDone && this.qNb === this.lastQDone) this.lastQ++
        this.qNb++
        this.focusIfNeeded()
      },
      isNumber: (event) => {
        event = event ? event : window.event
        let charCode = event.which ? event.which : event.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) event.preventDefault()
        else return true
      },
      true_false: function (resp) {
        // resp = true || false
        if (this.attempts[this.qNb-1]) return
        if (resp) this.current_attempt = this.current_attempt === true ? '' : true
        else this.current_attempt = this.current_attempt === false ? '' : false
      },

      check_response: function (quiz, response) {
        let message = '',
            comment = '',
            success = false

        if (quiz.type === 'QCM') {

          if (quiz.response.length === 0) {
            if (response.length === 1 && response[0] === quiz.choices.length) {
              message = 'Bien joué !'
              success = true
            }
            else message = 'Ratté'
            comment = 'Toutes les réponses sont fausses.'
          }
          else if (quiz.response.length === 1) {
            if (response.length === 1 && +response[0] === +quiz.response[0]) {
              message = 'Bien joué !'
              success = true
            }
            else message = 'Ratté'
            comment = 'La bonne réponse était la réponse ' + alphabet[quiz.response[0]]
          }
          else {
            let check = response.map(r => quiz.response.includes(r)),
                reverse_check = quiz.response.map(r => response.includes(r))

            // If at least something wrong
            if (check.includes(false)) message = 'Ratté'

            // If some answer is missing
            else if (reverse_check.includes(false)) message = 'Presque !'

            // Else, everything is correct
            else {
              message = 'Bien joué !'
              success = true
            }

            let respSorted = quiz.response.sort()
            comment = 'Les bonnes réponses étaient les réponses : '
                + respSorted.slice(0, -1).map(r => alphabet[r]).join(', ')
                + ' et ' + alphabet[respSorted[respSorted.length-1]]
          }


        }

        else if (quiz.type === 'TF') {
          if (response === quiz.response) {
            success = true
            message = 'Bien joué !'
            comment = `La proposition est bien ` + (quiz.response ? 'vraie.' : 'fausse.')
          }
          else {
            message = 'Ratté.'
            comment = `La proposition est ` + (quiz.response ? 'vraie.' : 'fausse.')
          }
        }

        else if (quiz.type === 'Number') {
          if (+response === +quiz.response) {
            success = true
            message = 'Bien joué !'
            comment = `La bonne réponse est bien ` + quiz.response + '.'
          }
          else {
            message = 'Ratté.'
            comment = `La bonne réponse était ` + quiz.response + '.'
          }
        }

        else if (quiz.type === 'Range') {
          if (response >= quiz.response.min && response <= quiz.response.max) {
            success = true
            message = 'Bien joué !'
          }
          else message = 'Ratté.'
          comment = `Les réponses acceptées sont comprises entre ${quiz.response.min} et ${quiz.response.max}.`
        }

        else if (quiz.type === 'Text') {
          if (quiz.response.includes(response.toLowerCase())) {
            success = true
            message = 'Bien joué !'
          }
          else {
            message = 'Ratté.'
          }
          comment = `Propositions acceptées :\n${quiz.response.join(', ')}.`
        }

        if (success) this.score++
        this.attempts[this.qNb-1]  = {
          success: success,
          message: message,
          comment: comment,
          text: quiz.tips,
          type: quiz.type,
          response: response,
          correctAnswer: quiz.response
        }
      },

      keyDownEvent: function (e) {
        if ((e.key === 'Enter' || e.keyCode === 13) && !this.ended) this.b_next_or_validate()
        if ((e.key === 'Backspace' || e.keyCode === 8) && e.target.tagName !== 'INPUT') this.b_previous()
        else if (this.currentQuiz.type === 'QCM') {
          let index = alphabet.indexOf(e.key.toUpperCase())
          if ((index !== -1 && this.currentQuiz.choices.length > index) || (this.currentQuiz.response.length === 0 && index === this.currentQuiz.choices.length))
            this.selectQCMOption(index)
        }
        else if (this.currentQuiz.type === 'TF') {
          if (e.key === 'v') this.true_false (true)
          if (e.key === 'f') this.true_false (false)
        }
      },
      focusIfNeeded: function () {

        // Do anything if its a QCM or a True/False (no need to focus)
        if (!this.currentQuiz || this.currentQuiz.type === 'QCM' || this.currentQuiz.type === 'TF') return

        // Also no need for focus if the question have already been responded
        if (this.lastQ !== this.qNb || this.lastQDone === this.lastQ) return

        // If possible, focus the first input
        let input = document.getElementsByClassName('quiz_input')
        if (!input || !input[0]) return
        input[0].focus()
      },

      closePopup: function () {
        document.getElementById('WarningPopupNewQuiz').remove()
      },
      clearData: function () {
        sessionStorage.clear()

        this.nbQ = 0
        this.qNb = 1
        this.score = 0
        this.lastQ = 1
        this.lastQDone = 0
        this.quiz = []
        this.selectedQCMOption = []
        this.current_attempt = ''
        this.attempts = []
        this.ended = false
      },
      loadQuiz: function () {
        this.closePopup()
        this.clearData()

        if (this.$route.path.endsWith('/test')) {
          axios.get(`/quiz/howManyQuiz/${this.$route.params.name}`)
            .then((res) => {
              this.nbQ = +res.data
              document.getElementById('WarningPopupHowManyQuiz').style.display = 'block'
            })
            .catch(error => {
                console.log(error)
              })
        }
        else {
          axios
              .get(`https://api.sv-quiz.fr/quiz/subject/${this.$route.params.quiz_id}`)
              .then((res) => {
                this.nbQ = res.data.quiz.length
                this.ue = res.data.ue
                this.subject = res.data.subject
                this.quiz = res.data.quiz
                    .sort(() => 0.5 - Math.random())
                    .map(q => {
                      if (q.type !== 'QCM') return q
                      let previous_correct_answer = q.response.map(r => q.choices[r])
                      q.choices = q.choices.sort(() => 0.5 - Math.random())
                      q.response = previous_correct_answer.map(r => q.choices.indexOf(r))
                      return q
                    })
              })
              .catch(error => {
                console.log(error)
              })
        }
      },
      loadExam: function () {
        document.getElementById('WarningPopupHowManyQuiz').remove()

        axios
          .get(`https://api.sv-quiz.fr/quiz/ue/${this.$route.params.name}/${this.nbQRequested}`)
          .then((res) => {
            this.nbQ = res.data.quiz.length
            this.ue = res.data.ue
            this.subject = false
            this.quiz = res.data.quiz
                .sort(() => 0.5 - Math.random())
                .map(q => {
                  if (q.type !== 'QCM') return q
                  let previous_correct_answer = q.response.map(r => q.choices[r])
                  q.choices = q.choices.sort(() => 0.5 - Math.random())
                  q.response = previous_correct_answer.map(r => q.choices.indexOf(r))
                  return q
                })
          })
          .catch(error => {
              console.log(error)
            })
      },
      saveResp: function () {
        let keys = ['qNb', 'score', 'lastQ', 'lastQDone', 'ended', 'ue', 'subject']
        for (let key of keys) sessionStorage.setItem(key, JSON.stringify(this[key]))

        sessionStorage.setItem('quiz', JSON.stringify(this.quiz))
        sessionStorage.setItem('attempts', JSON.stringify(this.attempts))
      },
      backupResp: function () {
        if (sessionStorage.getItem('ended') === 'true') return
        let ongoingQuiz = sessionStorage.getItem('quiz')
        let attempts = sessionStorage.getItem('attempts')
        if (!ongoingQuiz || !attempts) return

        ongoingQuiz = JSON.parse(ongoingQuiz)
        this.nbQ = ongoingQuiz.length
        this.quiz = ongoingQuiz
        this.attempts = JSON.parse(attempts)


        let keys = ['qNb', 'score', 'lastQ', 'lastQDone', 'ended', 'ue', 'subject']
        for (let key of keys) {
          let value = sessionStorage.getItem(key)
          this[key] = JSON.parse(value)
        }
        return true
      }
    }
  }
</script>